/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      avatar
      company
      title
      country
      city
      state
      postalCode
      lastLogin
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      avatar
      company
      title
      country
      city
      state
      postalCode
      lastLogin
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      avatar
      company
      title
      country
      city
      state
      postalCode
      lastLogin
      createdAt
      updatedAt
    }
  }
`;
export const createSurveyQuestion = /* GraphQL */ `
  mutation CreateSurveyQuestion(
    $input: CreateSurveyQuestionInput!
    $condition: ModelSurveyQuestionConditionInput
  ) {
    createSurveyQuestion(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const updateSurveyQuestion = /* GraphQL */ `
  mutation UpdateSurveyQuestion(
    $input: UpdateSurveyQuestionInput!
    $condition: ModelSurveyQuestionConditionInput
  ) {
    updateSurveyQuestion(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const deleteSurveyQuestion = /* GraphQL */ `
  mutation DeleteSurveyQuestion(
    $input: DeleteSurveyQuestionInput!
    $condition: ModelSurveyQuestionConditionInput
  ) {
    deleteSurveyQuestion(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const createSurveyAnswer = /* GraphQL */ `
  mutation CreateSurveyAnswer(
    $input: CreateSurveyAnswerInput!
    $condition: ModelSurveyAnswerConditionInput
  ) {
    createSurveyAnswer(input: $input, condition: $condition) {
      id
      answer
      userId
      questionId
      user {
        id
        firstName
        lastName
        email
        avatar
        company
        title
        country
        city
        state
        postalCode
        lastLogin
        createdAt
        updatedAt
      }
      question {
        id
        name
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateSurveyAnswer = /* GraphQL */ `
  mutation UpdateSurveyAnswer(
    $input: UpdateSurveyAnswerInput!
    $condition: ModelSurveyAnswerConditionInput
  ) {
    updateSurveyAnswer(input: $input, condition: $condition) {
      id
      answer
      userId
      questionId
      user {
        id
        firstName
        lastName
        email
        avatar
        company
        title
        country
        city
        state
        postalCode
        lastLogin
        createdAt
        updatedAt
      }
      question {
        id
        name
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteSurveyAnswer = /* GraphQL */ `
  mutation DeleteSurveyAnswer(
    $input: DeleteSurveyAnswerInput!
    $condition: ModelSurveyAnswerConditionInput
  ) {
    deleteSurveyAnswer(input: $input, condition: $condition) {
      id
      answer
      userId
      questionId
      user {
        id
        firstName
        lastName
        email
        avatar
        company
        title
        country
        city
        state
        postalCode
        lastLogin
        createdAt
        updatedAt
      }
      question {
        id
        name
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      type
      body
      button
      link
      createdAt
      updatedAt
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      type
      body
      button
      link
      createdAt
      updatedAt
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      type
      body
      button
      link
      createdAt
      updatedAt
    }
  }
`;
export const createEventConfig = /* GraphQL */ `
  mutation CreateEventConfig(
    $input: CreateEventConfigInput!
    $condition: ModelEventConfigConditionInput
  ) {
    createEventConfig(input: $input, condition: $condition) {
      id
      stage
      streamStartTime
      useBackupStream
      environment
      createdAt
      updatedAt
    }
  }
`;
export const updateEventConfig = /* GraphQL */ `
  mutation UpdateEventConfig(
    $input: UpdateEventConfigInput!
    $condition: ModelEventConfigConditionInput
  ) {
    updateEventConfig(input: $input, condition: $condition) {
      id
      stage
      streamStartTime
      useBackupStream
      environment
      createdAt
      updatedAt
    }
  }
`;
export const deleteEventConfig = /* GraphQL */ `
  mutation DeleteEventConfig(
    $input: DeleteEventConfigInput!
    $condition: ModelEventConfigConditionInput
  ) {
    deleteEventConfig(input: $input, condition: $condition) {
      id
      stage
      streamStartTime
      useBackupStream
      environment
      createdAt
      updatedAt
    }
  }
`;
export const createUserInteraction = /* GraphQL */ `
  mutation CreateUserInteraction(
    $input: CreateUserInteractionInput!
    $condition: ModelUserInteractionConditionInput
  ) {
    createUserInteraction(input: $input, condition: $condition) {
      id
      trigger
      type
      name
      email
      duration
      eventStage
      createdAt
      updatedAt
    }
  }
`;
export const createContactRequest = /* GraphQL */ `
  mutation CreateContactRequest(
    $input: CreateContactRequestInput!
    $condition: ModelContactRequestConditionInput
  ) {
    createContactRequest(input: $input, condition: $condition) {
      id
      firstName
      lastName
      phoneNumber
      email
      message
      demo
      userId
      createdAt
      updatedAt
    }
  }
`;
